import React, { useState } from 'react';
import { cn } from '../../../lib/utils';

type Side = 'top' | 'bottom' | 'left' | 'right';

export interface TaskyTooltipProps {
  content: React.ReactNode;
  side?: Side;
  delay?: number;
  className?: string;
  children: React.ReactElement;
}

const sideClass: Record<Side, string> = {
  top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
  left: 'right-full top-1/2 -translate-y-1/2 mr-2',
  right: 'left-full top-1/2 -translate-y-1/2 ml-2',
};

export const TaskyTooltip: React.FC<TaskyTooltipProps> = ({
  content,
  side = 'top',
  delay = 150,
  className,
  children,
}) => {
  const [open, setOpen] = useState(false);
  const timer = React.useRef<number | null>(null);

  const onEnter = () => {
    timer.current = window.setTimeout(() => setOpen(true), delay);
  };
  const onLeave = () => {
    if (timer.current) {
      window.clearTimeout(timer.current);
      timer.current = null;
    }
    setOpen(false);
  };

  return (
    <span className="relative inline-flex" onMouseEnter={onEnter} onMouseLeave={onLeave} onFocus={onEnter} onBlur={onLeave}>
      {children}
      {open && (
        <span
          role="tooltip"
          className={cn(
            'absolute z-50 whitespace-nowrap px-2 py-1 rounded-tasky-xs',
            'bg-dark text-white text-xs shadow-md',
            sideClass[side],
            className,
          )}
        >
          {content}
        </span>
      )}
    </span>
  );
};
